import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/types'
import { Outlet, useNavigate } from 'react-router-dom'

const AuthenticationGuard: FC = (): React.ReactElement => {
  const navigate = useNavigate()

  const isAuthenticated = useSelector((state: RootState) => state.auth.user.authenticated)

  useEffect(() => {
    if (!isAuthenticated) navigate('/login')
  }, [isAuthenticated, navigate])

  return isAuthenticated ? <Outlet /> : <></>
}

export default AuthenticationGuard
